import { Github, Linkedin, Mail, Twitter } from 'lucide-react'
import { Link } from 'react-router-dom'
import Logo from '../../components/ui/Logo'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const socialLinks = [
    { name: 'GitHub', url: 'https://github.com/Ogenbertrand', icon: Github },
    { name: 'LinkedIn', url: 'https://linkedin.com/in/bertrand-ogen-2a9108264', icon: Linkedin },
    { name: 'Twitter', url: 'https://twitter.com/ogenbertrand', icon: Twitter },
    { name: 'Email', url: 'mailto:ogenbertrand@gmail.com', icon: Mail },
  ]

  const navLinks = [
    { name: 'About', to: '/about' },
    { name: 'Experience', to: '/experience' },
    { name: 'Projects', to: '/projects' },
    { name: 'Skills', to: '/skills' },
    { name: 'Articles', to: '/articles' },
    { name: 'CV', to: '/cv' },
    { name: 'Contact', to: '/contact' },
  ]

  return (
    <footer className="border-t border-zinc-200 bg-canvas dark:border-zinc-800 dark:bg-canvas-dark">
      <div className="container-wide py-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div className="max-w-xs">
            <Link to="/" className="mb-3 inline-flex items-center gap-2.5 text-sm font-semibold text-zinc-950 dark:text-zinc-50">
              <Logo size={28} />
              Bertrand Ogen
            </Link>
            <p className="text-sm leading-relaxed text-zinc-500 dark:text-zinc-400">
              Full Stack Software Engineer & DevOps Engineer building reliable, scalable systems and open-source security tooling.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.to}
                className="text-sm text-zinc-500 transition-colors duration-200 hover:text-zinc-950 dark:text-zinc-400 dark:hover:text-zinc-50"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-zinc-200 pt-8 dark:border-zinc-800 sm:flex-row">
          <p className="text-xs text-zinc-400 dark:text-zinc-500">
            © {currentYear} Bertrand Ogen. All rights reserved.
          </p>

          <div className="flex items-center gap-3">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-lg p-2 text-zinc-400 transition-colors duration-200 hover:bg-zinc-100 hover:text-zinc-950 dark:text-zinc-500 dark:hover:bg-zinc-900 dark:hover:text-zinc-50"
                aria-label={link.name}
              >
                <link.icon size={16} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
